import React from 'react';
export function BonusHeadline() {
  return <section className="bg-navy py-12 md:py-20 px-6 text-center border-t border-white/10" data-id="element-95">
      <div className="max-w-4xl mx-auto" data-id="element-96">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 font-heading leading-tight" data-id="element-97">
          And Because You're Acting Today — You Get These 4 Bonuses Free.
        </h2>
        <p className="text-xl text-gold font-semibold mb-12 font-body" data-id="element-98">
          (Total Value: $39.96 — Yours at Zero Extra Cost)
        </p>
        <div className="text-lg md:text-xl text-white font-body leading-relaxed space-y-6 text-left max-w-3xl mx-auto" data-id="element-99">
          <p data-id="element-100">
            The Survival Kit alone will walk you through every step of the
            process. But I wanted to make sure that the moment you download it,
            you have everything you need to take action — not next week, not
            after "figuring it out."{' '}
            <strong className="text-white" data-id="element-101">Tonight.</strong>
          </p>
          <p data-id="element-102">
            So I'm including 4 done-for-you bonus tools — each one built for a
            specific moment you're going to face in the next 72 hours.
          </p>
        </div>
      </div>
    </section>;
}